var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "76px",
    viewBox: "0 0 93 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "77.1758805%",
    cy: "25.7379553%",
    fx: "77.1758805%",
    fy: "25.7379553%",
    r: "79.0943368%",
    gradientTransform: "translate(0.771759,0.257380),scale(0.998289,1.000000),rotate(110.131578),translate(-0.771759,-0.257380)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.89743889e-07%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084C8A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1572CB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    transform: "translate(-787.000000, -3772.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13",
    transform: "translate(787.500000, 3772.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "url(#radialGradient-1)",
    x: 0,
    y: 0,
    width: 75.5011136,
    height: 75.3719008,
    rx: 12.5795053
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.442701,43.1104433 L44.442701,15.7024793 L75.9014983,15.7024793 L75.9014983,43.1104433 L89.2906039,43.1104433 C89.8428886,43.1104433 90.2906039,43.5581585 90.2906039,44.1104433 C90.2906039,44.3679647 90.1912566,44.615559 90.0132543,44.801657 L62.3400508,73.7334495 C61.1948104,74.9307758 59.2957849,74.9729999 58.0984585,73.8277595 C58.0663268,73.7970256 58.0348823,73.7655812 58.0041484,73.7334495 L30.3309449,44.801657 C29.9491981,44.4025482 29.9632728,43.7695397 30.3623816,43.3877929 C30.5484796,43.2097905 30.7960739,43.1104433 31.0535953,43.1104433 L44.442701,43.1104433 L44.442701,43.1104433 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature-1.ca4c3f8b322f4ba3eead6f86f92f1740.svg";
export { ForwardRef as ReactComponent };